export const hide = (b: boolean) => (b ? { display: 'none' } : {});
